import { Input as MuiInput, InputProps, styled } from '@mui/material'
import React from 'react'

const Input = styled((props: InputProps) => <MuiInput disableUnderline {...props} />)(
  ({ theme }) => ({
    backgroundColor: '#fff',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1, 1),
    border: '1px solid black',
    marginBottom: '5px',
  }),
)

export default Input
